import { createV3Queries } from "@query/utils/createV3Queries";
import { internalAccountsApi } from "@api";

export const queriesInternalAccounts = createV3Queries(
  "internalAccountsApi",
  internalAccountsApi,
  {
    createInternalAccount: queries => ({
      dependencies: () => [queries.listInternalAccounts.queryKeyBase]
    })
  }
);
